import { useTranslation } from 'react-i18next';
import {
  COLATOOL_CURRENT_TOOL_ID,
  colatoolNavItems,
} from './config/colatoolNav';

export type MenuItem = {
  href?: string;
  logo?: string;
  label?: string;
  about?: string;
  divider?: boolean;
  /** ColaTool 主站其它工具（绝对路径，非 Hash 路由） */
  colatoolSite?: boolean;
  /** 当前所在工具，侧栏置灰不可点 */
  current?: boolean;
};

export function useColaToolSiteMenus(): MenuItem[] {
  const { i18n } = useTranslation();
  const isZh = i18n.language?.startsWith('cn');
  return colatoolNavItems.map((item) => ({
    href: item.path,
    logo: item.logo,
    label: isZh ? item.titleZh : item.title,
    colatoolSite: true,
    current: item.id === COLATOOL_CURRENT_TOOL_ID,
  }));
}

export function useMenus(): MenuItem[] {
  const { t } = useTranslation();
  const colatoolMenus = useColaToolSiteMenus();
  return [
    {
      href: '/',
      logo: 'home',
      label: t('menu./.label'),
    },
    {
      href: '/url-encode',
      logo: 'url',
      label: t('menu./url-encode.label'),
    },
    {
      href: '/json-format',
      logo: 'json',
      label: t('menu./json-format.label'),
    },
    {
      href: '/js-beautifier',
      logo: 'js',
      label: t('menu./js-beautifier.label'),
    },
    {
      href: '/js-obfuscator',
      logo: 'js',
      label: t('menu./js-obfuscator.label'),
    },
    {
      href: '/text-case',
      logo: 'text',
      label: t('menu./text-case.label'),
    },
    {
      href: '/image-to-base64',
      logo: 'image',
      label: t('menu./image-to-base64.label'),
    },
    {
      href: '/code-to-image',
      logo: 'code-image',
      label: t('menu./code-to-image.label'),
    },
    {
      href: '/hash',
      logo: 'hash',
      label: t('menu./hash.label'),
    },
    {
      href: '/generate-password',
      logo: 'password',
      label: t('menu./generate-password.label'),
    },
    {
      href: '/html-formatter',
      logo: 'html5',
      label: t('menu./html-formatter.label'),
    },
    {
      href: '/html-escape',
      logo: 'html5',
      label: t('menu./html-escape.label'),
    },
    {
      href: '/html-to-markdown',
      logo: 'markdown',
      label: t('menu./html-to-markdown.label'),
    },
    {
      href: '/markdown-to-html',
      logo: 'html5',
      label: t('menu./markdown-to-html.label'),
    },
    {
      href: '/base64-encoder',
      logo: 'base64',
      label: t('menu./base64-encoder.label'),
    },
    {
      href: '/qrcode-generator',
      logo: 'qrcode',
      label: t('menu./qrcode-generator.label'),
    },
    {
      href: '/chinese-pinyin-conversion',
      logo: 'pinyin',
      label: t('menu./chinese-pinyin-conversion.label'),
    },
    {
      href: '/generate-github-badges',
      logo: 'github',
      label: t('menu./generate-github-badges.label'),
    },
    {
      href: '/toml-to-json',
      logo: 'toml',
      label: t('menu./toml-to-json.label'),
    },
    {
      href: '/css-easing-animation',
      logo: 'css3',
      label: t('menu./css-easing-animation.label'),
    },
    {
      href: '/css-formatter',
      logo: 'css3',
      label: t('menu./css-formatter.label'),
    },
    {
      href: '/simple-markdown-editor',
      logo: 'markdown',
      label: t('menu./simple-markdown-editor.label'),
    },
    {
      href: '/jwt-decoder',
      logo: 'jwt',
      label: t('menu./jwt-decoder.label'),
    },
    {
      href: '/json-yaml',
      logo: 'yaml',
      label: t('menu./json-yaml.label'),
    },
    {
      href: '/json-xml',
      logo: 'xml',
      label: t('menu./json-xml.label'),
    },
    {
      href: '/json-ini',
      logo: 'ini',
      label: t('menu./json-ini.label'),
    },
    {
      href: '/pdf-to-img',
      logo: 'pdf',
      label: t('menu./pdf-to-img.label'),
    },
    {
      href: '/exif-viewer',
      logo: 'image',
      label: t('menu./exif-viewer.label'),
    },
    {
      href: '/svg-optimizer',
      logo: 'svg',
      label: t('menu./svg-optimizer.label'),
    },
    {
      href: '/amount-in-rmb',
      logo: 'rmb',
      label: t('menu./amount-in-rmb.label'),
    },
    {
      href: '/standard-chinese-characters',
      logo: 'hans',
      label: t('menu./standard-chinese-characters.label'),
    },
    {
      href: '/simplified-traditional-chinese',
      logo: 'traditional-chinese',
      label: t('menu./simplified-traditional-chinese.label'),
    },
    {
      divider: true,
    },
    ...colatoolMenus,
  ];
}
